import { collectAuthUserEmails, isAdminRole, parseEmailList } from '../../lib/fireflyRoles.js'

export function canEditModelsClient(user) {
  if (!user || !user.id) return false

  if (user.isFireflyAdmin === true) {
    return true
  }

  const resolvedRole = user.fireflyRole || user.userType || user.app_metadata?.fireflyRole
  if (isAdminRole(resolvedRole)) {
    return true
  }

  const metadata = user.user_metadata || {}
  const role = typeof metadata.role === 'string' ? metadata.role.toLowerCase() : ''

  if (isAdminRole(role)) {
    if (import.meta?.env?.DEV) {
      console.log('[ADMIN_CHECK] Role-based admin access granted:', { userId: user.id, role })
    }
    return true
  }

  const allowList = parseEmailList(import.meta?.env?.VITE_ADMIN_EMAILS || '')

  if (!allowList.length) {
    if (import.meta?.env?.DEV) {
      console.log('[ADMIN_CHECK] No admin allowlist configured, denying access', { userId: user.id, role })
    }
    return false
  }

  let emails = []
  try {
    emails = Array.from(collectAuthUserEmails(user))
  } catch (error) {
    if (import.meta?.env?.DEV) {
      console.warn('[ADMIN_CHECK] Failed to normalize user emails', { userId: user.id, error })
    }
  }

  const hasAllowlistAccess = emails.some((email) => allowList.includes(email))

  if (import.meta?.env?.DEV) {
    console.log('[ADMIN_CHECK] Email-based admin evaluation:', {
      userId: user.id,
      role,
      emails,
      hasAllowlistAccess
    })
  }

  return hasAllowlistAccess
}

